export default __webpack_public_path__ + "static/media/pack4e.05d03ac4.png";